// video-guides.service.ts
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '@env';

export interface MuxTokenResponse {
  playbackId: string;
  token: string;
  url: string;
}

@Injectable({ providedIn: 'root' })
export class VideoGuidesService {

  private baseUrl = environment.apiUrl; // change if needed

  constructor(private http: HttpClient) {}

  /** Fetch fresh Mux playback token */
  getPlaybackToken(playbackId: string): Observable<MuxTokenResponse> {
    return this.http.get<MuxTokenResponse>(`${this.baseUrl}/token/${playbackId}`);
  }
}
